import { ApiResponseErrorItem } from "shared/network/apiResponseSchema";

class HandledErrors {
  private messagesWithoutPath: string[] = [];
  private messagesWithPath: { path: string[]; message: string }[] = [];
  private unknownErrors: ApiResponseErrorItem[] = [];

  public addMessageWithoutPath = (message: string) =>
    this.messagesWithoutPath.push(message);

  public addMessageWithPath = (path: string[], message: string) =>
    this.messagesWithPath.push({ path, message });

  public getMessagesWithoutPath = () => this.messagesWithoutPath;

  public getMessagesWithPath = () => this.messagesWithPath;

  public addUnknownError = (unknownError: ApiResponseErrorItem) =>
    this.unknownErrors.push(unknownError);

  public getUnknownErrors = () => this.unknownErrors;

  public getAllMessages = () => [
    ...this.getMessagesWithoutPath(),
    ...this.getMessagesWithPath().map((item) => item.message),
  ];
}

export default HandledErrors;
